import { PARAMETER_OPTIONS } from "./constants";
import { todayIsoDate } from "./dateHelpers";
import type { DateParameter } from "./types";

export type LegSeed = {
  parameter: DateParameter | null;
  date: string | null;
};

/** Default `(parameter, date)` pair used when seeding a CUSTOM date leg on a
 * kind transition or when toggling between parameter / date mode.
 *
 * Seeds parameter mode with the first available `PARAMETER_OPTIONS` entry so
 * the BE per-leg invariant ("exactly one of parameter / date is set") is
 * satisfied without user input. Falls back to today's date when the parameter
 * catalogue is empty so the invariant still holds. */
export const seedLegDefaults = (): LegSeed => {
  const firstParameter = PARAMETER_OPTIONS[0]?.value;
  if (firstParameter !== undefined) {
    return { parameter: firstParameter, date: null };
  }
  return { parameter: null, date: todayIsoDate() };
};

/** Variant used by `DateLeg` when the user toggles into date mode. Leaves the
 * date blank so the user can choose explicitly; Yup validation prevents saving
 * without a selection. */
export const seedLegDateMode = (): LegSeed => ({
  parameter: null,
  date: null,
});
